import Swal from "sweetalert2";
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from '../../components/Navbar';

const AddFamilyExpense = () => {
    const [formData, setFormData] = useState({
        FamilyCategory: '',
        FamilyExpense: '',
        FamilyExpenseDetails: ''
    });
    const [familyCategories, setFamilyCategories] = useState([]);
    const fetchCategories = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOST_SERVER}family-category`);
            await setFamilyCategories(response.data)
        } catch (error) {
            console.error('Error fetching Categoris:', error);
            return [];
        }
    };
    const showSuccessAlert = (text) => {
        Swal.fire({
            title: "نجاح!",
            text: text,
            icon: "success",
            confirmButtonText: "حسناً",
        });
    };

    const showErrorAlert = (text) => {
        Swal.fire({
            title: "خطأ!",
            text: text,
            icon: "error",
            confirmButtonText: "حاول مرة أخرى",
        });
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res =await axios.post(`${process.env.REACT_APP_HOST_SERVER}family-expense`, formData);
            const expenseId = res.data._id;
            await axios.post(`${process.env.REACT_APP_HOST_SERVER}family-box`, {
                familyExpenseAmount: expenseId,
                amountType: 'خدمة',
                details: formData.FamilyExpenseDetails,
            });
            await axios.post(`${process.env.REACT_APP_HOST_SERVER}notification`, {
                Notifaction: `تم اضافة مصروف بنجاح`,
            });
            showSuccessAlert('تمت الاضافة بنجاح');
            setFormData({ FamilyCategory: '', FamilyExpense: '', FamilyExpenseDetails: '' });
        } catch (error) {
            if (error.response && error.response.data.error) {
                showErrorAlert("حدث خطأ اثناء الاضافة");
            } else {
                showErrorAlert('حدث خطأ اثناء الاضافة');
            }
        }
    };
    useEffect(() => {
        fetchCategories();
    }, []);
    return (
        <div className="px-8 py-5 bg-gray-100 min-h-screen">
            <Navbar />
            <h1 className="text-4xl text-center font-extrabold my-10 text-blue-600">اضف مصروف جديد للخدمة</h1>
            <div className="max-w-4xl mx-auto p-8 bg-white rounded-xl shadow-lg">
                <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-8">
                    <div>
                        <label htmlFor="FamilyCategory" className="block text-lg font-medium mb-2">الفئة </label>
                        <select
                            id="FamilyCategory"
                            name="FamilyCategory"
                            value={formData.FamilyCategory}
                            onChange={handleChange}
                            className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        >
                            <option value="" selected>من فضلك اختار فئة</option>
                            {familyCategories && familyCategories.map((item)=>(
                                <option key={item._id} value={item._id}>{item.FamilyCategory}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label htmlFor="FamilyExpense" className="block text-lg font-medium mb-2">المبلغ</label>
                        <input
                            type="text"
                            id="FamilyExpense"
                            name="FamilyExpense"
                            value={formData.FamilyExpense}
                            onChange={handleChange}
                            className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                    <div>
                        <label htmlFor="FamilyExpenseDetails" className="block text-lg font-medium mb-2">تفاصيل المصروف</label>
                        <textarea
                            id="FamilyExpenseDetails"
                            name="FamilyExpenseDetails"
                            value={formData.FamilyExpenseDetails}
                            onChange={handleChange}
                            className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                    <div className="col-span-1">
                        <button
                            type="submit"
                            className="w-full bg-blue-600 text-white text-lg font-semibold py-3 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
                        >
                            أضافة مصروف
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddFamilyExpense;
